module.exports = __webpack_public_path__ + "static/media/portfolio2.35b5680d.jpg";